import { apiSlice } from '../api/apiSlice';
import io from 'socket.io-client';
export const messagesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMessages: builder.query({
      query: ({ id }) =>
        `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
      transformResponse: (apiResponse, meta) => {
        const totalCount = meta.response.headers.get('X-Total-Count');
        return {
          data: apiResponse,
          totalCount,
        };
      },
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
      ) {
        // create socket
        const socket = io(process.env.REACT_APP_API_URL, {
          reconnectionDelay: 500,
          reconnection: true,
          reconnectionAttemps: 10,
          transports: ['websocket'],
          agent: false,
          upgrade: false,
          rejectUnauthorized: false,
        });

        try {
          await cacheDataLoaded;
          socket.on('messages', (data) => {
            updateCachedData((draft) => {
              //    draft এর ভিতরে নির্দিষ্ট conversationId ওয়ালা মেসেজগুলা ফেচ করে আনা হয়েছিল।
              //    এখান থেকে conversationId পেলে সার্ভার থেকে আসা ডাটার সাথে মিলেয়ে দেখা যাবে ।
              //    সার্ভার থেকে যেই conversationId ওয়ালা মেসেজটি এসেছে , ওই conversationId এর সাথে যেই টা মিলে ওইটার ক্যাশ আপডেট করতে হবে ।

              const conversationId = draft?.data[0]?.conversationId;

              // eslint-disable-next-line eqeqeq
              if (conversationId == data?.data?.conversationId) {
                //  loggedIn user যদি সেন্ডার না হয় তাহলে তার ক্যাশ আপডেট করতে হবে। কারণ তার ক্যাশ editCoversation এর মধ্যে passimistically updated হচ্ছে , তাই এইখান থেকেও আপডেট করলে তা তার ক্যাশে redundent হয়ে যাবে এবং ui তেও দুইওবার রেন্ডার হবে।
                if (arg?.userEmail !== data?.data?.sender?.email) {
               
                  draft?.data?.push(data?.data);
                }
              }
            });
          });
        } catch (err) {}

        try {
          await cacheEntryRemoved;
          socket.close();
        } catch (error) {}
      },
    }),
    getMoreMessages: builder.query({
      query: ({ id, page }) =>
        `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const messages = await queryFulfilled;

          if (messages?.data?.length > 0) {
            // update message cache pessimistically start
            dispatch(
              apiSlice.util.updateQueryData(
                'getMessages',
                { id: arg.id, userEmail: arg.userEmail },
                (draft) => {
             
                  return {
                    data: [...draft.data, ...messages.data],
                    totalCount: Number(draft.totalCount),
                  };
                }
              )
            );

            // update message cache pessimistically start
          }
        } catch (error) {}
      },
    }),
    addMessage: builder.mutation({
      query: (data) => ({
        url: '/messages',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useGetMessagesQuery, useAddMessageMutation } = messagesApi;
